import { toast } from "react-toastify";
import { useInspectionClient } from "./useInspectionClient";

export const usePostForm = <TInput extends string | Object | FormData, TOutput>(
  endpoint: string,
  callback: (response: TOutput) => void
) => {
    const client = useInspectionClient();
  const postForm = async (data: TInput) => {
    try {
      // Write input to log
      console.log("Input values", data);

      // Send post request to API.
      const response = await client.api(endpoint).post(data);

      // console.log("Response Data", response);

      // Redirect to AddContact page if successful.
      const output = response.data as TOutput;

      // Run the callback
      callback(output);
    } catch (error: any) {
      toast.error(error.message);
    }
  };

  return postForm;
};

export default usePostForm;
